<div [innerHtml]="data.input.data | sanitizeHtml"></div>
